module.exports = __webpack_public_path__ + "img/b6_01.3535d6ac.jpg";